import React from 'react';
import CustomLink from 'components/CustomLink';

import UserImage from '@components/UserImage';
import ProgressIndicator from '@components/ProgressIndicator';
import Spacer from '@components/Spacer';
import s from '../UserProfile.module.scss';

const UserProfileShimmer: React.FC = () => (
  <div className={s.wrapper}>
    <nav className={s.nav}>
      <div />
      <UserImage size={32} />
      <CustomLink to="#" className={s.navAccount}>
        Account Details
      </CustomLink>
    </nav>
    <main className={s.main}>
      <Spacer />
      <ProgressIndicator isCentered />
    </main>
  </div>
);

export default UserProfileShimmer;
